/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Body for recording affirmative exam code-of-conduct acknowledgement.
 */
export interface OralExamAcknowledgeConductRequest {
  policyVersion: string;
}
